function distanceCalculator(lat1, lon1, lat2, lon2, unit) {
  if ((lat1 == lat2) && (lon1 == lon2)) {
    return 0;
  }
  else {
    var radlat1 = Math.PI * lat1/180;
    var radlat2 = Math.PI * lat2/180;
    var theta = lon1-lon2;
    var radtheta = Math.PI * theta/180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180/Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit=="K") { dist = dist * 1.609344 }
    if (unit=="N") { dist = dist * 0.8684 }
    return dist.toFixed(4);
  }
}

let map;
const googleMaps = {
countryZoom: null,
locationSet: false,
scriptsLoaded: false,
difMapFlag: false, // for setting two different  infoWindow content
hotelIcon: "/templates/images/icons/icon-hotel.svg",

init({
       API_KEY,
       country,
       filteredMap = [],
       propertyLevel = false,
       selectLocationMap,
       theme
     })

{
  window.MAPS = googleMaps;
  this.API_KEY = API_KEY;
  this.countryZoom = country;
  this.locations = filteredMap;
  this.markers = [];
  this.propertyLevel = propertyLevel;
  this.selectLocationMap = selectLocationMap;
  this.theme = theme;

  if (!this.scriptsLoaded) {
    this.loadScript();
  } else {
    this.initMap();
  }
},

loadScript() {
  window.__maps_initMap = this.initMap;
  // const script2 = document.createElement('script');
  // script2.id = 'google-maps-cluster';
  // script2.type = 'text/javascript';
  // script2.defer = true;
  // script2.async = false;
  // script2.src = `/us/js/markerclusterer.js`;
  // // script2.src = `https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js`;
  // // script2.src = `https://unpkg.com/@googlemaps/markerclusterer@1.0.1/dist/index.min.js`;
  // document.body.appendChild(script2);
  const script = document.createElement('script');
  script.id = 'google-maps';
  script.type = 'text/javascript';
  script.defer = true;
  script.async = false;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${
    this.API_KEY
  }&callback=__maps_initMap`;
  document.body.appendChild(script);
  this.scriptsLoaded = true;
},

initMap() {
  if (googleMaps.propertyLevel) {
    if($('body.location').hasClass('location-exists')) {
    return;
    }
    }
   else {
    if($('body.location').hasClass('desti-exists')) {
    return;
    }
   }
  const $map = document.getElementById('map');
  const $mapDestination = document.getElementById('map-destination');
  if (window.google) {
    const bounds = new window.google.maps.LatLngBounds();
    const infowindow = new window.google.maps.InfoWindow();

    let locations;
    if (googleMaps.propertyLevel) {
      let mapOptions = {
        zoom: 10,
        styles: [{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"color":"#e3e4e6"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#e3e4e6"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"color":"#e3e4e6"},{"weight":7.5}]},{"featureType":"poi.attraction","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.place_of_worship","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","stylers":[{"visibility":"off"}]},{"featureType":"poi.sports_complex","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#a8a8ab"}]}]
      }
      map = new window.google.maps.Map($mapDestination, mapOptions);
      $('body.location').addClass('location-exists');
    }
    else {
      var mapOptions = {
        zoom: 4,
        styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"color":"#e3e4e6"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"geometry","stylers":[{"color":"#cbe6c3"}]},{"featureType":"poi.business","elementType":"geometry","stylers":[{"color":"#cbe6c3"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#cbe6c3"},{"weight":8}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#cbe6c3"}]},{"featureType":"poi.park","elementType":"geometry.stroke","stylers":[{"color":"#cbe6c3"}]},{"featureType":"road","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"water","stylers":[{"color":"#aad2e3"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#aadaff"}]}]
    };
      map = new window.google.maps.Map($map, mapOptions);
      $('body.location').addClass('desti-exists');
    }
    const setLocations = () => {
      locations = googleMaps.locations.map(location => {
        const srclat = googleMaps.locations[0].lat;
        const srclng = googleMaps.locations[0].lng;
        const dstlat = location.lat ? parseFloat(location.lat) : parseFloat(location.latitude);
        const dstlng = location.lat ? parseFloat(location.lng) : parseFloat(location.longitude);
        const locationDistance = (googleMaps.locations.length > 1) ? distanceCalculator(srclat, srclng, dstlat, dstlng, 'M') : '';
        return {
          title: location.value ? location.value : location.name,
          city: location.city,
          state: location.state_name,
          country: location.country,
          countryIndex: location.countryIndex,
          description: location.data
              ? location.data.location
              : `${location.city && location.city + ','} ${location.country &&
              location.country}`,
          address: location.address ? location.address : location.address1,
          shortDescription: location.shortDescription ? location.shortDescription : "",
          externalLink: location.external_link ? location.external_link : "",
          propertyLink: location.property_link,
          locationDistance : locationDistance,
          zipcode : location.zip,
          image: location.img ? location.img : null,
          thumbnailImageAlt: location.thumbnailImageAlt ? location.thumbnailImageAlt : null,
          location: {
            lat: dstlat,
            lng: dstlng
          },
          id: location.data ? '0000' : location.index
        };
      });
      if (googleMaps.propertyLevel) {
        locations.forEach(location => {
        if (location.location.lat && location.location.lat) {
          bounds.extend(location.location);
          googleMaps.addMarker({
            map,
            infowindow,
            location
          });
        }
      });
      } else {
        let isDest = true;
        locations.forEach(location => {
          if (location.location.lat && location.location.lat) {
            bounds.extend(location.location);
            googleMaps.addMarker({
              map,
              infowindow,
              location,
              isDest
            });
          }
        });      
      }
    };

    setLocations();
    window.google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
      if (this.countryZoom) {
        if (googleMaps.locations.length < 100) {
          const zoom = map.getZoom() - 1;
          this.countryZoom = zoom;
          map.setZoom(zoom);
        } else {
          const zoom = map.getZoom();
          this.countryZoom = zoom;
          map.setZoom(zoom);
        }
        if (googleMaps.propertyLevel) {
          setLocations();
        }
      } else {
        if (window.innerWidth < 475) {
          map.setZoom(1);
        } else if (window.innerWidth < 1024) {
          map.setZoom(2);
        } else {
          map.setZoom(3);
        }
        if (googleMaps.propertyLevel) {
          setLocations();
        }
      }
    });
    google.maps.event.addListener(map, 'tilesloaded', () =>{
      $('#map-destination img').each(function(i, eimg){
        if(!eimg.alt || eimg.alt ===""){
           eimg.alt = `Google Maps Image${i}`;
        }
      });
   });
    map.fitBounds(bounds);
    if (googleMaps.propertyLevel) {
      window.google.maps.event.addListenerOnce(map, 'idle', () => {
        map.setZoom(10);
      });
    } else {
      // const styles = [{
      //   url: '/templates/images/icon-google-map-red1.png',
      //   height: 55,
      //   width: 32,
      //   anchor: [12, 0],
      //   textColor: '#fff',
      //   textSize: 12
      //   }]
        
      // var markerCluster = new window.MarkerClusterer(map, googleMaps.markers,{
      //   maxZoom: 15,
      //   styles,
      //   imagePath: '/templates/images/icon-google-map-red'
      // })
      // console.log(markerCluster);
      // google.maps.event.addListener(markerCluster, 'clusterclick', function(cluster) {
      //   console.log('Cluster clicked');
      // });
    }
    if (googleMaps.locationSet === false && googleMaps.propertyLevel) {
      googleMaps.difMapFlag = true;
      googleMaps.locationSet = true;
      $('.maps-accordion .maps-accordion-header').append(`
                  <p class="explore">Explore</p>
                  <p class="location-name">${googleMaps.locations[0].value}</p>
              `);
    }
  }
},

returnMapInstance() {
  if(map) {
    return map;
  }
},

createMapInstance() {
  this.initMap();
},

addMarker({ map, infowindow, location, isDest = false }) {
  let marker;
  const srclat = googleMaps.locations[0].lat;
  const srclng = googleMaps.locations[0].lng;
  const dstlng = location.location.lat;
  const dstlat = location.location.lng;
  if(isDest) {
    marker = new google.maps.Marker({
      map,
      icon: {
        scaledSize: new google.maps.Size(31, 43),
        url:  this.theme.googleMapsSrc
      },
      label: {
        class: 'google-maps-label',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        text: "1"
      },
      optimized: false,
      position: location.location,
    });
  } else{
    marker = new window.google.maps.Marker({
      map,
      icon: {
        scaledSize: new google.maps.Size(31, 43),
        //url: this.theme.googleMapsSrc
        url: (srclat != dstlng) ? this.theme.googleMapsSrc : this.hotelIcon
      },
      label: {
        class: 'google-maps-label',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        //text: location.countryIndex.toString()
        text: (srclat != dstlng) ? location.countryIndex.toString() : ' '
      },
      optimized: false,
      position: location.location
    });
  }
  marker.id = location.id;
  const locationDistance = distanceCalculator(srclng, srclat, dstlat, dstlng, 'M');
  
  function decisionOnMarker() {
    const infoMarkupPropertyLevel  = `<div class="google-infoContent" style="width:374px">
    <div class="media-object">
         <div class="media-left">
            <img style="width: 100px; height: 100px;" src="${location.image}" alt="${location.thumbnailImageAlt}">
            <a href="${location.externalLink}" style="font-weight: bold;margin-top: 17px;" target="_blank">visit website</a>
        </div>

        <div class="media-body" tabindex="0">
             <h4 class="google-maps-title">${location.title}</h4>
             <p class="address">${location.address.replace(/,\s?,/g, ', ')} <span>${location.zipcode}</span></p>
             <p class="distance">${locationDistance} miles from the hotel</p>
             <p class="description" style="margin: 5px 0">${location.shortDescription}</p>
         </div>
       </div>
    </div>`;
    const infoMarkup = `<div class="google-image-less" style="width:240px"> 
    <a href="${location.externalLink}" target="_blank" ><h4 class="google-maps-title">${location.title}</h4></a>
    <div class="media-body-less" tabindex="0">
      <p class="address-less">${location.address.replace(/,\s?,/g, ', ')} <span>${location.zipcode}</span></p>
      <p class="distance" style="font-weight: bold;">${locationDistance} miles from the hotel</p>
      <p class="description" style="margin: 5px 0">${location.shortDescription}</p>
      <a href="${location.externalLink}" style="font-weight: bold;margin-top: 10px;" target="_blank">visit website</a>
    </div>
    </div>`;
    if(location.image) {
      return infoMarkupPropertyLevel;
    } else {
      return infoMarkup
    }
  }

  const infoMarkup = `<a href= ${location.propertyLink} target="_blank" ><h4 class="google-maps-title">${location.title}</h4></a>
                      <span class="address">${location.address}, ${location.city} </span><br/>
                      <span>${location.state}, ${location.country} ${location.zipcode}</span>`;
  window.google.maps.event.addListener(marker, 'click', () =>  {
    const srclat = googleMaps.locations[0].lat;
    const dstlng = location.location.lat;
    if (infowindow) {
      infowindow.close();
     }
     map.panTo(marker.getPosition()); 
     map.panBy(-20, -80);
     infowindow.setContent((googleMaps.difMapFlag && srclat != dstlng) ? decisionOnMarker() : infoMarkup);
     infowindow.open(map, marker);
     if (this.selectLocationMap && googleMaps.propertyLevel) {
       this.selectLocationMap(location.country);
     }
  });
  this.markers.push(marker);
  }
};

export default googleMaps;
